export const baTagData = [
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '06ee605a226e4ecab6fda144cf8ec163',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-6-DI-1',
      Name: '車位押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-DI-1',
      Name: '車位押扣',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1停車押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '738f45de945942ae8a131825c9236d1f',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-6-DI-3',
      Name: '電信室磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-DI-3',
      Name: '電信室磁簧',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1電信室開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9b2c94c5275f4873a17990a70fc29f5a',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-6-DI-4',
      Name: '油壓機房磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-DI-4',
      Name: '油壓機房磁簧',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1油壓機房開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '123c1740143a4253aeadf80757a7354e',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-6-UI-7',
      Name: '電器室磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-UI-7',
      Name: '電器室磁簧',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1電器室開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '30a291714c6440ceae2910b1059dd1fd',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-6-UI-8',
      Name: 'B1F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-UI-8',
      Name: 'B1F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '754c38100f6b432f9ce1c7d701220176',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-6-UI-9',
      Name: 'B1F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-6-UI-9',
      Name: 'B1F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: 'B1F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '552ddc9a06db4e04ae788e4786aed1df',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-7-DI-1',
      Name: '消防運轉',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-DI-1',
      Name: '消防水泵運轉',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '消防運轉',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'e18f74c33be741d68f5f188707a8cd69',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-7-DI-2',
      Name: '消防過載',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-DI-2',
      Name: '消防水泵過載',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '消防過載',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'ef327107ff9246bebbc12076e34690a9',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-7-DI-3',
      Name: '消防缺水',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-DI-3',
      Name: '消防水泵缺水',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '消防缺水',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'eec1b31b8d1b4124a973204e22e238a9',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-7-DI-4',
      Name: '泡沫運轉',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-DI-4',
      Name: '泡沫水泵運轉',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '泡沫運轉',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8c4c741ddf534d51b0e8a9bbdd14d149',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-7-DI-5',
      Name: '泡沫過載',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-DI-5',
      Name: '泡沫水泵過載',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '泡沫過載',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b5c41846891d435583399e5ba6583b11',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-7-UI-6',
      Name: '泡沫缺水',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-UI-6',
      Name: '泡沫水泵缺水',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '泡沫缺水',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '2131114b33a84d6f851512d67c344c7c',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-7-UI-7',
      Name: '灑水運轉',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-UI-7',
      Name: '灑水泵浦運轉',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '灑水運轉',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a291249a5d894522bb8ba74a7e2cf040',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-7-UI-8',
      Name: '灑水過載',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-UI-8',
      Name: '灑水泵浦過載',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '灑水過載',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'f38a529361444963af55ebf9ef9a9478',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-7-UI-9',
      Name: '灑水缺水',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-7-UI-9',
      Name: '灑水泵浦缺水',
      Type: '緊急'
    },
    Location: 'A棟B1公區',
    Status: false,
    Message: '灑水缺水',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '0f41fb9737d74998a017479f1aef22b7',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-8-DI-3',
      Name: '大廳押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-DI-3',
      Name: '大廳押扣',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '1F大廳押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'cbc2bcbf32214563a5f822d67f1ee55e',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-8-DI-4',
      Name: '1F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-DI-4',
      Name: '1F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '1F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6f76f9cd8a464b93a84ce9893854a030',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-8-DI-5',
      Name: '1F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-DI-5',
      Name: '1F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '1F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '43e85d436f324b088651dc864e3d48db',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-8-UI-6',
      Name: '1F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-UI-6',
      Name: '1F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '1F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8bd74c466e064d18bdb107781758dc7c',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-8-UI-7',
      Name: '1F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-UI-7',
      Name: '1F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '1F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'f0ccc8819c3d4f159cbf6e26c806bbe1',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-8-UI-8',
      Name: '消防警報',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-8-UI-8',
      Name: '消防警報',
      Type: '緊急'
    },
    Location: 'A棟1F公共',
    Status: false,
    Message: '消防警報',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'c1c37f00df9344008cd6874cb520a947',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-9-DI-1',
      Name: '2F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-DI-1',
      Name: '2F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟2F公共',
    Status: false,
    Message: '2F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a4adcf6b0c994732b45bcdd46439eca0',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-9-DI-2',
      Name: '2F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-DI-2',
      Name: '2F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟2F公共',
    Status: false,
    Message: '2F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '287e5d4cdb85444bb4cf91fa755b6965',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-9-DI-3',
      Name: '2F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-DI-3',
      Name: '2F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟2F公共',
    Status: false,
    Message: '2F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '5a63a63941f74e78b8a7bec0351e197b',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-9-DI-4',
      Name: '2F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-DI-4',
      Name: '2F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟2F公共',
    Status: false,
    Message: '2F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'f64a61c81d044c1ca55cc89bf9814a30',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-9-DI-5',
      Name: '3F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-DI-5',
      Name: '3F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟3F公共',
    Status: false,
    Message: '3F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8d4a049b893a41f4b8545b6b793d800f',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-9-UI-6',
      Name: '3F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-UI-6',
      Name: '3F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟3F公共',
    Status: false,
    Message: '3F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '39397af76bf84f5293ab6bea2d36bb7e',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-9-UI-7',
      Name: '3F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-UI-7',
      Name: '3F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟3F公共',
    Status: false,
    Message: '3F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '17cb46b2c221459d840775b8336b728b',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-9-UI-8',
      Name: '3F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-9-UI-8',
      Name: '3F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟3F公共',
    Status: false,
    Message: '3F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'dc13ff6fec6d47aba608ad2ccd2eca28',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-10-DI-1',
      Name: '4F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-DI-1',
      Name: '4F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟4F公共',
    Status: false,
    Message: '4F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'c05849b9ce8a428ba4faf85602d6bdca',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-10-DI-2',
      Name: '4F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-DI-2',
      Name: '4F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟4F公共',
    Status: false,
    Message: '4F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6f20349fb3004804bf2239db19d3772b',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-10-DI-3',
      Name: '4F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-DI-3',
      Name: '4F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟4F公共',
    Status: false,
    Message: '4F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '58b06ab6de0340d6be580b9c3dd35dea',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-10-DI-4',
      Name: '4F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-DI-4',
      Name: '4F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟4F公共',
    Status: false,
    Message: '4F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '7ee5e99eea12417fad2282ba8ce02981',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-10-DI-5',
      Name: '5F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-DI-5',
      Name: '5F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟5F公共',
    Status: false,
    Message: '5F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'ff04448363134adfac95e1c67b456213',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-10-UI-6',
      Name: '5F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-UI-6',
      Name: '5F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟5F公共',
    Status: false,
    Message: '5F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '3efe69996abf48288d86402c109cdd1c',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-10-UI-7',
      Name: '5F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-UI-7',
      Name: '5F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟5F公共',
    Status: false,
    Message: '5F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'd794a8e0461d49618a54f3c33a023008',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-10-UI-8',
      Name: '5F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-10-UI-8',
      Name: '5F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟5F公共',
    Status: false,
    Message: '5F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '87417911d0264a6c8627c45c8e5a12d5',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-11-DI-1',
      Name: '6F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-DI-1',
      Name: '6F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟6F公共',
    Status: false,
    Message: '6F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a25d5b98569848cebfb21773d351a89e',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-11-DI-2',
      Name: '6F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-DI-2',
      Name: '6F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟6F公共',
    Status: false,
    Message: '6F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'c3d2f7e038534d01bfe95ad0b6c7a122',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-11-DI-3',
      Name: '6F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-DI-3',
      Name: '6F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟6F公共',
    Status: false,
    Message: '6F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '217d748aded14a4dba2236137bab0fdb',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-11-DI-4',
      Name: '6F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-DI-4',
      Name: '6F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟6F公共',
    Status: false,
    Message: '6F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '2dafc14e525240ac8f763d6d5be531f0',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-11-DI-5',
      Name: '7F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-DI-5',
      Name: '7F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟7F公共',
    Status: false,
    Message: '7F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '805a2a57bc3e47e9b6c1d49d46861065',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-11-UI-6',
      Name: '7F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-UI-6',
      Name: '7F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟7F公共',
    Status: false,
    Message: '7F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '920bcf67619d440f8f67e4c4dc7c13b2',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-11-UI-7',
      Name: '7F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-UI-7',
      Name: '7F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟7F公共',
    Status: false,
    Message: '7F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '0ece9e5f7654419daaa9ca8accf044fc',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-11-UI-8',
      Name: '7F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-11-UI-8',
      Name: '7F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟7F公共',
    Status: false,
    Message: '7F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9e394cf498844125a9405afdd040b6c9',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-12-DI-1',
      Name: '8F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-DI-1',
      Name: '8F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟8F公共',
    Status: false,
    Message: '8F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b657a518c15d4f75a7403f70682c8cde',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-12-DI-2',
      Name: '8F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-DI-2',
      Name: '8F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟8F公共',
    Status: false,
    Message: '8F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'f29683bd33d54503b9565f037049882c',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-12-DI-3',
      Name: '8F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-DI-3',
      Name: '8F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟8F公共',
    Status: false,
    Message: '8F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9e9391110faa4b129a11dbac20918627',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-12-DI-4',
      Name: '8F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-DI-4',
      Name: '8F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟8F公共',
    Status: false,
    Message: '8F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9db3b5f6f2c14ba9959eefc0d9590bd5',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-12-DI-5',
      Name: '9F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-DI-5',
      Name: '9F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟9F公共',
    Status: false,
    Message: '9F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '876795263cad4bbe85b6f381d8e1da2d',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-12-UI-6',
      Name: '9F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-UI-6',
      Name: '9F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟9F公共',
    Status: false,
    Message: '9F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '015ecc800d3e4161aae958c06f8f87b4',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-12-UI-7',
      Name: '9F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-UI-7',
      Name: '9F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟9F公共',
    Status: false,
    Message: '9F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8fc50d2445ec461eb174c881380e7477',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-12-UI-8',
      Name: '9F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-12-UI-8',
      Name: '9F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟9F公共',
    Status: false,
    Message: '9F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '230faf2d1dde4f5280d1236925742129',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-13-DI-1',
      Name: '10F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-DI-1',
      Name: '10F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟10F公共',
    Status: false,
    Message: '10F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '2b72108f4d7b45c8a4025046508209a1',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-13-DI-2',
      Name: '10F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-DI-2',
      Name: '10F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟10F公共',
    Status: false,
    Message: '10F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '38a21fdc7ab543b088b55edae32afb80',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-13-DI-3',
      Name: '10F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-DI-3',
      Name: '10F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟10F公共',
    Status: false,
    Message: '10F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '630ad6fe77a34379a4eb3d5db4c56269',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-13-DI-4',
      Name: '10F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-DI-4',
      Name: '10F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟10F公共',
    Status: false,
    Message: '10F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '63603f4b9ea34620afc8a7482701fe43',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-13-DI-5',
      Name: '11F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-DI-5',
      Name: '11F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟11F公共',
    Status: false,
    Message: '11F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9f93cd2bd1064350b73c994f9ff8b0ea',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-13-UI-6',
      Name: '11F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-UI-6',
      Name: '11F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟11F公共',
    Status: false,
    Message: '11F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '51ed5c1539ac475c98b1decac8f228ac',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-13-UI-7',
      Name: '11F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-UI-7',
      Name: '11F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟11F公共',
    Status: false,
    Message: '11F B樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '0e98a3338f2d48d3b3663f875ec8d6aa',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-13-UI-8',
      Name: '11F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-13-UI-8',
      Name: '11F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟11F公共',
    Status: false,
    Message: '11F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '11259a88d238467082115a4b148a9453',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-14-DI-1',
      Name: '12F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-DI-1',
      Name: '12F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟12F公共',
    Status: false,
    Message: '12F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6a483001f13c40d99b02ba7f83e2c6f2',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-14-DI-2',
      Name: '12F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-DI-2',
      Name: '12F A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟12F公共',
    Status: false,
    Message: '12F A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9449ce421858473a8d93dd5f3972e51b',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-14-DI-3',
      Name: '12F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-DI-3',
      Name: '12F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟12F公共',
    Status: false,
    Message: '12F B樓梯開門',
    Remark: '',
    OriginalData: {},
    FENote: '緊急逃生圖'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '2d95679ad86448d5bef10c128cfea89b',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-14-DI-4',
      Name: '12F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-DI-4',
      Name: '12F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟12F公共',
    Status: false,
    Message: '12F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a417f3d186b548a6ba37abd1c6e22d20',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-20-14-DI-5',
      Name: '13F A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-DI-5',
      Name: '13F A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟13F公共',
    Status: false,
    Message: '13F A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '7f0d0836c3c14c64b64e4a072a6956cb',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-20-14-UI-6',
      Name: '13F A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-UI-6',
      Name: '13F A樓梯押扣',
      Type: '緊急'
    },
    Location:
      '13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣1',
    Status: false,
    Message:
      '13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣13F A樓梯押扣1',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '668a44fecac044cf9f839bef2b354a22',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-20-14-UI-7',
      Name: '13F B樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-UI-7',
      Name: '13F B樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟13F公共',
    Status: false,
    Message: '13F B樓梯開門',
    Remark: '',
    OriginalData: {},
    FENote: '緊急逃生圖'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '89ddd1dbb9f14013a552c43eb554c03b',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-20-14-UI-8',
      Name: '13F B樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-20-14-UI-8',
      Name: '13F B樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟13F公共',
    Status: false,
    Message: '13F B樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '0bf4b98e89054d788b17121d3211fb69',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-15-DI-1',
      Name: 'RF A樓梯磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-15-DI-1',
      Name: 'RF A樓梯磁簧',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: 'RF A樓梯開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '082d44f952e04e1b9e40a93bd281b5de',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'BUOU-10-15-DI-2',
      Name: 'RF A樓梯押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-15-DI-2',
      Name: 'RF A樓梯押扣',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: 'RF A樓梯押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a2ae5d0230aa41d8a0b53f32e8ed39a8',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-15-DI-5',
      Name: 'R2F押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-15-DI-5',
      Name: 'R2F押扣',
      Type: '緊急'
    },
    Location: 'A棟R2F公共',
    Status: false,
    Message: 'R2F梯機房外押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'd0e69c9d266d4dc2b783bf7d9a60374a',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-15-UI-6',
      Name: 'R2F電梯機房磁簧',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-15-UI-6',
      Name: 'R2F電梯機房磁簧',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: 'R2F電梯機房開門',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '4da2a15e4caf4a7eb702551cc441bd57',
    AutoTrigger: 0,
    Level: 2,
    Tag: {
      Id: 'BUOU-10-15-UI-7',
      Name: '門外押扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-15-UI-7',
      Name: '門外押扣',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: 'RF A露臺押扣',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8aa743de90cb4fd2b9689bb16b69f1d0',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-16-DI-1',
      Name: '消防水池微動開關',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-16-DI-1',
      Name: '消防水池微動開關',
      Type: '緊急'
    },
    Location:
      'A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF公共A棟RF',
    Status: false,
    Message:
      '消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防水池蓋開啟消防',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '1e8e303408194799b03cc4cbbfcea2cc',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'BUOU-10-16-DI-2',
      Name: '消防水池 高水位',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-16-DI-2',
      Name: '消防水池 高水位',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: '消防水池 高水位',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a1e7b7db95474b3b8c01811ee490204b',
    AutoTrigger: 0,
    Level: 1,
    Tag: {
      Id: 'BUOU-10-16-DI-3',
      Name: '消防水池 低水位',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'BUOU-10-16-DI-3',
      Name: '消防水池 低水位',
      Type: '緊急'
    },
    Location: 'A棟RF公共',
    Status: false,
    Message: '消防水池 低水位',
    Remark: '',
    OriginalData: {}
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '87120f5da68142f88dedc7848f899ed4',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-A-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '2261e4a5efca457f8eb2184f28e0dcc9',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-A-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b14cf656524a45c8b32cb3b2ca6c1117',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '9d34b88536934cdea3b454da65df8c23',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'e63d505685d144689659ddf9d8c27b0e',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00005',
      Name: '廚房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '廚房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'fc75c33aa7c54d6aa1f4bfca9caa0d37',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00006',
      Name: '浴室',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '浴室偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8111b4afb58d4a8e841f139bad4cbd89',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00007',
      Name: '主臥',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '主臥偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6d93b87571c644a2a64bd13e8ddc7ca6',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-A-00008',
      Name: '書房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-A',
      Name: '雲端室內機A',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '書房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '39bb97cca75b4152a1971642b66e20ba',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-B-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '4d0fef9be8b8497aa23e468f9f9a82bd',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-B-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '7a66f45fa6ad426b98b44c8b3f79464f',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b45338012d9d43ff90d5c5ea7df4242a',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '80595b85efde4800af41d35eab31a8b1',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00005',
      Name: '廚房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '廚房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '60b58e544cdc4ac28b2da7f4c0f34827',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00006',
      Name: '浴室',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '浴室偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '38e72a09e4144b78852f7fc71a72bd2a',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00007',
      Name: '主臥',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '主臥偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'f8a65048aa47450cbf57e1619fbdbae7',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-B-00008',
      Name: '書房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-B',
      Name: '雲端室內機B',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '書房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'a05ba671ba934213a50bdeebc52c257b',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-C-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '0a69bdbd81b74556a9aa7639919a5ce9',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-C-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'aa6e592860674182a18e2f378b4de7da',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'd3325681a6704a608e775eba1c5b9369',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6de1e10c5a1f4522914a21b70f624528',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00005',
      Name: '廚房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '廚房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '56de424ca3f242f8b7394eebc6a68388',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00006',
      Name: '浴室',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '浴室偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '10bc4255f2414ad3a63d73c0417cf945',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00007',
      Name: '主臥',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '主臥偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8baf23b270f2447388b2f613393d00ed',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-C-00008',
      Name: '書房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-C',
      Name: '雲端室內機C',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '書房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b6af1cc6281c49a5a817d0ce4bd9be8a',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-D-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '76f627a561ca4cdc92f1ee2ef5e380eb',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-D-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '41caba87617b47128457d7e346b74b4d',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'e730a696b6a94096aa9141dde036eed6',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '1826f8bf9a224230be41f1033392d356',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00005',
      Name: '廚房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '廚房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '381f5569030546b6a482cd7686107ccb',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00006',
      Name: '浴室',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '浴室偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '77325d51e0ae4049a09b996bd88d90c2',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00007',
      Name: '主臥',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '主臥偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'd582e4d51ec9417589b108e268891ca2',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-D-00008',
      Name: '書房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-D',
      Name: '雲端室內機D',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '書房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '6c6766c70cda4f8997b7746ed42c1ade',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-E-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'e93a0d17de4f4dda8d751dff599d4985',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-E-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '3ff77005a2714436b536b3ba28ce8e64',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'b2cb66c57a9e46679b93a00afa6517b8',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'd9dd054d702a4da1a57b8f2b0cde29b3',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00005',
      Name: '廚房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '廚房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '3abbe9e8dee742a0b09b201dc9bb0925',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00006',
      Name: '浴室',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '浴室偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '485f107fc5004cd2a05fdda9bf108e80',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00007',
      Name: '主臥',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '主臥偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: 'ce2883a0642f4bc89fce08744315eaf5',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-E-00008',
      Name: '書房',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-E',
      Name: '雲端室內機E',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '書房偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '3e4c0715489f454eb6bc6fb415bab8b9',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-F-00001',
      Name: '緊急壓扣',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-F',
      Name: '雲端室內機F',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '住戶透過雲端室內機觸發緊急通話按鈕',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8ed559d57a534f2c9731dbc92ca91f64',
    AutoTrigger: 0,
    Level: 4,
    Tag: {
      Id: 'private-area-F-00002',
      Name: '瓦斯',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-F',
      Name: '雲端室內機F',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '瓦斯偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '8eab71fcb32e45b5bb098525c978c31a',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-F-00003',
      Name: '大門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-F',
      Name: '雲端室內機F',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '大門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  },
  {
    WarningTime: '2024/04/22T07:50:37Z',
    WarningId: '7bd0f038ad3548ffb624085dda0aaa75',
    AutoTrigger: 0,
    Level: 3,
    Tag: {
      Id: 'private-area-F-00004',
      Name: '後門',
      Value: '0',
      Unit: '警報'
    },
    Device: {
      Id: 'private-area-F',
      Name: '雲端室內機F',
      Type: '緊急'
    },
    Location: 'A',
    Status: false,
    Message: '後門偵測異常',
    Remark: '',
    OriginalData: {},
    FENote: '雲端室內機'
  }
]
